module.exports = "<div bind-dynamic-page=\"$ctrl.html\"></div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/template-widget/template-widget.component.html
// module id = 636
// module chunks = 0